export default __webpack_public_path__ + "static/media/menu4.432244c6.png";